var _module_exports = "<div class=\"row\" data-ng-controller=\"ServicesTabsController as vm\">\n  <div class=\"wrapper-md\">\n    <div class=\"col-md-12\">\n      <div class=\"panel panel-default m-t-sm\">\n        <uib-tabset>\n          <uib-tab heading=\"Menu highlights\"\n                         active=\"true\">\n            <div data-ng-include=\"'/app/merchants/services/services.html'\"></div>\n          </uib-tab>\n        </uib-tabset>\n      </div>\n    </div>\n  </div>\n</div>\n";;
var path = '/app/merchants/services/services-tabs/services-tabs.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/merchants/services/services-tabs/services-tabs.html
// module id = 1095
// module chunks = 0